import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const alpha = /[A-Za-z]/;
const alphanum = /[A-Za-z0-9]/;
// const num = /[^\d]/;
const num = /^\d$/;

class TemplateInput extends React.Component {
	onKeyPress = (evt) => {
		const { regex } = this.props;

		// eslint-disable-next-line react/prop-types
		if (!regex.test(evt.key)) {
			 //evt.preventDefault(); //commented to allow Enter button to submit the search queries or a form
		}
	}
	
	render() {
		return <Input onKeyPress={this.onKeyPress} {...this.props} />;
	}
}

export class AlphaInput extends React.Component {
	render() {
		return <TemplateInput regex={alpha} {...this.props} />;
	}
}

export class AlphaNumInput extends React.Component {
	render() {
		return <TemplateInput regex={alphanum} {...this.props} />;
	}
}

export class NumberInput extends React.Component {

	 handleChange = (e) => {
        const { onChange } = this.props;
        const raw = e && e.target ? String(e.target.value) : '';
        const cleaned = raw.replace(/[^\d]/g, '');
        if (typeof onChange === 'function') {
            onChange({ target: { value: cleaned } });
        }
    };
	render() {
		return <TemplateInput regex={num} {...this.props} onChange={this.handleChange} />;
	}
}

export class RegexInput extends React.Component {
	render() {
		const { regex } = this.props;

		return <TemplateInput regex={regex} {...this.props} />;
	}
}

RegexInput.propTypes = {
	regex: PropTypes.instanceOf(RegExp).isRequired
};

//format value to accept alphanumeric, space and selected characters(-_)
export function regExCondition(value, condition){
	// const inputValue = value === undefined ? '' : value;
	if(condition === 'conditionA'){
		const formatValue = value.replace(/[^\w\s-]/gi, '');
		return formatValue;
	}
}

export function formatMobileNumber(value) {
	if (!value) return null;
  
	const phoneNumber = value.replace(/[^\d]/g, "");
	const phoneNumberLength = phoneNumber.length;
  
	if (phoneNumberLength < 4) return phoneNumber
	else if (phoneNumberLength < 7) {
	  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
	}
	else
	return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice( 3, 6 )}-${phoneNumber.slice(6, 10)}`;
  }

// format value on change - 
// auto apply comma for thousand, can accept period for decimal
export function formatValueOnChange(value, format){
    if (!value) return value;

    if(format === 'decimal'){
      const checkValue = value.replace(/[^\d.]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }else if(format === 'numeric'){
      const checkValue = value.replace(/[^\d]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }else if(format === 'numberonly'){
      const checkValue = value.replace(/[^\d]/g, "");
      return checkValue;
    }else if(format === 'decimalonly'){
      const checkValue = value.replace(/[^\d.]/g, "");
      return checkValue;
    }else if(format === 'withnegative'){
      const checkValue = value.replace(/[^\d.-]/g, "");
      const formatValue = checkValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return formatValue;
    }
};